import React, {useState,useEffect} from 'react';
import bookingService from "../../../../../../services/booking.service";
import { useEyeconxStore } from "../../../../../../store/eyeconxStore";
import Loading from "../../../../../common/Loading";
import DoctorAppointmentTypes from "./DoctorAppointmentTypes";
import DoctorHours from "./DoctorHours";


const DoctorsCard = ({ doctor, onBack }) => {
    const clinicId = useEyeconxStore((state) => state.user.clinicId);
    const [isLoading, setIsLoading] = useState(true);
    const [doctorInfo, setDoctorInfo] = useState(null);
    useEffect(() => {

    })
    const fetchDoctorInfo = async () => {
        try{
            const res = await bookingService.getDoctorDetails(clinicId, doctor.id);
            setDoctorInfo(res.data);
            setIsLoading(false);
        } catch(error){
            console.log(error);
        }finally{
            setIsLoading(false);
        }
    }

    const getInitials = (name) => {
        if (!name) return 'DR';
        return name
            .split(' ')
            .map(part => part[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    const getStatusBadge = (isActive) => {
        return isActive ?
            <span className="badge bg-success">Active</span> :
            <span className="badge bg-secondary">Inactive</span>;
    };

    return (
        <div className="card mt-3">

            <div className="card-body">
                <div className="row">
                    <div className="col-md-4 mb-3">
                        <div className="text-center mb-4">
                            {doctor?.photoUrl ? (
                                <img
                                    src={doctor.photoUrl}
                                    alt={doctor.name}
                                    className="rounded-circle mb-3"
                                    style={{width: '100px', height: '100px', objectFit: 'cover'}}
                                />
                            ) : (
                                <div
                                    className="rounded-circle d-flex align-items-center justify-content-center bg-primary text-white fw-bold mx-auto mb-3"
                                    style={{width: '100px', height: '100px', fontSize: '2rem'}}
                                >
                                    {getInitials(doctor?.name)}
                                </div>
                            )}
                            <h4 className="fw-bold text-dark">{doctor?.name || 'Unknown Doctor'}</h4>
                            {getStatusBadge(doctor?.isActive)}
                        </div>
                    </div>
                    <div className="col-md-8">
                            <div className="d-flex flex-column justify-content-between mb-3">
                                <h4 className="fw-bold text-dark">{doctor?.name || 'Unknown Doctor'}</h4>
                                <div className="alert alert-info">
                                    <strong>Bio</strong> : {doctor?.bio}
                                </div>
                                <DoctorAppointmentTypes doctor={doctor} />
                            </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default DoctorsCard;